import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyBRL'
})
export class CurrencyBRL implements PipeTransform {

  transform(value: number | string): string {
    // if(value){
    //   return `R$ `;
    // }
    // Verifica se o valor é numérico
    if (value && isNaN(parseFloat(value.toString()))) {
      return 'R$ 0,00'; // Retorna um valor padrão caso não seja numérico
    }

    // Formata o valor para o formato brasileiro
    const formattedValue = parseFloat(value.toString())
      .toFixed(2)
      .replace('.', ',')
      .replace(/\d(?=(\d{3})+,)/g, '$&.');

    return `R$ ${formattedValue}`;
  }
}
